"use client";

import { Bed, Users } from "lucide-react";

export interface VehicleSleepingArrangementsProps {
  sleeps: number;
  kingBeds: number;
  queenBeds: number;
  fullBeds: number;
  twinBeds: number;
}

export function VehicleSleepingArrangements({
  sleeps,
  kingBeds,
  queenBeds,
  fullBeds,
  twinBeds,
}: VehicleSleepingArrangementsProps) {
  const items = [
    { label: "Sleeps", count: sleeps, icon: Users },
    { label: "King Beds", count: kingBeds, icon: Bed },
    { label: "Queen Beds", count: queenBeds, icon: Bed },
    { label: "Full Beds", count: fullBeds, icon: Bed },
    { label: "Twin Beds", count: twinBeds, icon: Bed },
  ];

  return (
    <div className="mb-8 border-y border-gray-200 py-8">
      <h3 className="text-xl font-bold mb-4">Sleeping Arrangements</h3>
      <div className="flex flex-wrap gap-6">
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-3 min-w-[140px]">
            <div className="bg-gray-100 p-3 rounded-lg flex items-center justify-center">
              <item.icon className="h-6 w-6 stroke-1.5" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg leading-none">
                {item.count}
              </span>
              <span className="text-sm text-muted-foreground">
                {item.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
